// import "./App.css";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import Layout from "./components/Layout.jsx";
import Login, { ForgetPassword, OutlookCallback } from "./pages/login";
import TeamsCallback from "./components/TeamsCallback.jsx";
import Profile from "./pages/profile";
import Meetings, { MeetingDetail, NewMeeting } from "./pages/meeting";
import CaseList, { NewCase, CaseDetails, AddCaseUsers } from "./pages/case";
import DocumentsHome, {
  CaseDocuments,
  NewCaseDocuments,
} from "./pages/documents";
import NegotiationHome, {
  CaseNegotiation,
  NegotiationDetails,
} from "./pages/negotiation";
import SettlementAgreement from "./pages/negotiation/SettlementAgreement.jsx";
import EventCalendar from "./pages/calendar";
import CaseTimeline from "./pages/timeline";
import Deadlines from "./pages/deadlines";

import { getUser } from "./actions/auth";
import { homePathFor } from "./config/roles";

import { Button, Box, CircularProgress, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import CustomizedSnackbars from "./components/Snackbar.jsx";
import CustomAlert from "./components/Alert.jsx";
import Users, { NewUser, UserDetail } from "./pages/users";
import QuestionsList, {
  NewQuestion,
  QuestionDetail,
} from "./pages/case-questions/index.js";
import DisputeItemsHome from "./pages/dispute-items/dispute-items-home.jsx";
import DisputeItemDetails from "./pages/dispute-items/item-details.jsx";
import CaseDisputeItems from "./pages/dispute-items/case-dispute-items.jsx";
import Customer from "./pages/customer/Customer";
import SubmittedQuesAns from "./pages/submittedQuesAns/quesAns-list.js";
import SubmittedQuesAnsDetail from "./pages/submittedQuesAns/quesAns-detail.js";
import PaymentForm from "./pages/payment/payment-form.js";
import Register from "./pages/Register/register.js";
import Dashboard from "./pages/dashboard/dashboard.jsx";
import CustomerDetail from "./pages/customer/customer-detail.jsx";
import LoginMfa from "./pages/mfa/loginMfa.jsx";

function App() {
  return (
    <Routes>
      <Route
        path="login"
        element={
          <>
            <Login />
            <CustomizedSnackbars />
          </>
        }
      />
      <Route
        path="verify-mfa"
        element={
          <>
            <LoginMfa />
            <CustomizedSnackbars />
          </>
        }
      />
      <Route
        path="signup"
        element={
          <>
            <Register />
            <CustomizedSnackbars />
          </>
        }
      />
      <Route
        path="forget-password"
        element={
          <>
            <ForgetPassword />
            <CustomizedSnackbars />
          </>
        }
      />
      <Route path="auth/outlook/callback" element={<OutlookCallback />} />
      <Route path="auth/teams/callback" element={<TeamsCallback />} />

      {/* <Route
        path="/admin"
        element={<RequireAdminAuth role={user.role} loggedIn={isLoggedIn} />}
      > */}
      {/* <Route path="employees" element={<Layout><EmployeeList /></Layout>}/>
        <Route path="employees/:id" element={<Layout><EmployeeView /></Layout>}/>
        
        <Route path="projects" element={<Layout><ProjectList /></Layout>}/>
        <Route path="projects/:id" element={<Layout><ProjectView /></Layout>}/>

        <Route path="purchase-orders" element={<Layout><PurchaseList /></Layout>}/>
        <Route path="purchase-orders/:id" element={<Layout><PurchaseView /></Layout>}/>

        <Route path="vendor" element={<Layout><VendorList /></Layout>}/>
        <Route path="vendor/:id" element={<Layout><VendorView /></Layout>}/>

        <Route path="customer" element={<Layout><CustomerList/></Layout>}/>
        <Route path="customer/:id" element={<Layout><CustomerView /></Layout>}/> */}
      {/* </Route> */}

      <Route path="/" element={<RequireAuth />}>
        <Route
          path="dashboard"
          element={
            <DashboardRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </DashboardRoute>
          }
        />

        <Route
          path="profile"
          element={
            <Layout>
              <Profile />
            </Layout>
          }
        />

        <Route
          path="users"
          element={
            <Layout>
              <Users />
            </Layout>
          }
        />
        <Route
          path="users/new"
          element={
            <Layout>
              <NewUser />
            </Layout>
          }
        />
        <Route
          path="users/:id"
          element={
            <Layout>
              <UserDetail />
            </Layout>
          }
        />

        {/* <Route
          path="meetings"
          element={
            <Layout>
              <Meetings />
            </Layout>
          }
        />
        <Route
          path="meetings/new"
          element={
            <Layout>
              <NewMeeting />
            </Layout>
          }
        />
        <Route
          path="meetings/:id"
          element={
            <Layout>
              <MeetingDetail />
            </Layout>
          }
        /> */}

        <Route
          path="cases"
          element={
            <Layout>
              <CaseList />
            </Layout>
          }
        />
        <Route
          path="cases/new"
          element={
            <Layout>
              <NewCase />
            </Layout>
          }
        />
        <Route
          path="cases/:id"
          element={
            <Layout>
              <CaseDetails />
            </Layout>
          }
        />
        <Route
          path="cases/:id/meetings/new"
          element={
            <Layout>
              <NewMeeting />
            </Layout>
          }
        />
        <Route
          path="cases/:id/users"
          element={
            <Layout>
              <AddCaseUsers />
            </Layout>
          }
        />

        <Route
          path="documents"
          element={
            <Layout>
              <DocumentsHome />
            </Layout>
          }
        />
        <Route
          path="documents/:caseId"
          element={
            <Layout>
              <CaseDocuments />
            </Layout>
          }
        />
        <Route
          path="documents/:caseId/new"
          element={
            <Layout>
              <NewCaseDocuments />
            </Layout>
          }
        />

        <Route
          path="questions"
          element={
            <Layout>
              <QuestionsList />
            </Layout>
          }
        />
        <Route
          path="questions/new"
          element={
            <Layout>
              <NewQuestion />
            </Layout>
          }
        />
        <Route
          path="questions/:id"
          element={
            <Layout>
              <QuestionDetail />
            </Layout>
          }
        />

        <Route
          path="submittedques"
          element={
            <Layout>
              <SubmittedQuesAns />
            </Layout>
          }
        />
        <Route
          path="submittedques/:id"
          element={
            <Layout>
              <SubmittedQuesAnsDetail />
            </Layout>
          }
        />

        {/* shams */}
        <Route
          path="customer"
          element={
            <Layout>
              <Customer />
            </Layout>
          }
        />
        <Route
          path="customer/:id"
          element={
            <Layout>
              <CustomerDetail />
            </Layout>
          }
        />

        <Route
          path="calendar"
          element={
            <Layout>
              <EventCalendar />
            </Layout>
          }
        />

        <Route
          path="timeline"
          element={
            <Layout>
              <CaseTimeline />
            </Layout>
          }
        />
        <Route
          path="timeline/:caseId"
          element={
            <Layout>
              <CaseTimeline />
            </Layout>
          }
        />

        <Route
          path="deadlines"
          element={
            <Layout>
              <Deadlines />
            </Layout>
          }
        />

        <Route
          path="negotiation"
          element={
            <Layout>
              <NegotiationHome />
            </Layout>
          }
        />
        <Route
          path="negotiation/:caseId"
          element={
            <Layout>
              <CaseNegotiation />
            </Layout>
          }
        />
        <Route
          path="negotiation/:caseId/:negId/agreement"
          element={<SettlementAgreement />}
        />
        <Route
          path="negotiation/:caseId/:negId"
          element={
            <Layout>
              <NegotiationDetails />
            </Layout>
          }
        />

        <Route
          path="dispute-items"
          element={
            <Layout>
              <DisputeItemsHome />
            </Layout>
          }
        />
        <Route
          path="dispute-items/:caseId"
          element={
            <Layout>
              <CaseDisputeItems />
            </Layout>
          }
        />
        <Route
          path="dispute-items/:caseId/:negId"
          element={
            <Layout>
              <DisputeItemDetails />
            </Layout>
          }
        />
        <Route
          path="payment"
          element={
            <Layout>
              <PaymentForm />
            </Layout>
          }
        />
        {/* <Route path="projects/:id" element={<Layout><WorkerProject/></Layout>} /> */}
      </Route>

      <Route path="*" element={<Nothing />}></Route>
    </Routes>
  );
}

export default App;

function RequireAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isLoggedIn, suspense, data } = useSelector((state) => state.user);
  const roles = data?.roles;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !isLoggedIn) {
      // console.log("Token but not logged in");
      dispatch(getUser(token));
    } else if (isLoggedIn) {
      // console.log("Logged in");
      navigate(pathname === "/" ? homePathFor(roles) : pathname);
    } else {
      // console.log("No token no logged in")
      navigate("/login", { replace: true });
    }
  }, [pathname, isLoggedIn]);

  return suspense ? (
    <Loading />
  ) : (
    <>
      <Outlet />
      <CustomizedSnackbars />
      <CustomAlert />
    </>
  );
}

// The Dashboard is not available to arbitrators; send them to their landing page.
function DashboardRoute({ children }) {
  const roles = useSelector((state) => state.user.data?.roles);
  return /^arbitrator$/i.test(roles || "") ? <Navigate to={homePathFor(roles)} replace /> : children;
}

function RequireAdminAuth({ loggedIn, role = "user" }) {
  if (loggedIn) {
    if (role === "admin") {
      return (
        <>
          <Outlet />
          {/* <AlertBox />  */}
        </>
      );
    } else {
      return <AccessDenied />;
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

function Nothing() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className="w-full h-screen"
    >
      <Box textAlign="center">
        <Typography variant="h3" fontWeight="600">
          Nothing Here !!!
        </Typography>
        <br />
        <Link to="/">
          <Button variant="contained">Back To Home</Button>
        </Link>
      </Box>
    </Box>
  );
}

function AccessDenied() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className="w-full h-screen"
    >
      <Box textAlign="center">
        <Typography variant="h3" fontWeight="600">
          Access Denied !!!
        </Typography>
        <Typography variant="h6">Only Allowed to Admins.</Typography>
        <br />
        <Link to="/">
          <Button variant="contained">Back To Home</Button>
        </Link>
      </Box>
    </Box>
  );
}

function Loading() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      className="w-full h-screen"
    >
      <Box textAlign="center">
        <Typography variant="h3" fontWeight="600">
          Logging In ...
        </Typography>
        <br />
        <CircularProgress />
      </Box>
    </Box>
  );
}
